import { DeesElement, property, html, customElement, TemplateResult } from '@designestate/dees-element';
import * as domtools from '@designestate/dees-domtools';

import * as deesCatalog from '@designestate/dees-catalog';
deesCatalog;

@customElement('sio-combox')
export class SioCombox extends DeesElement {
  public static demo = () => html` <sio-combox></sio-combox> `;
  
  @property({ type: Object })
  public referenceObject: HTMLElement;

  /**
   * computes the button offset
   */
  public cssComputeHeight() {
    let height = window.innerHeight < 760 ? window.innerHeight : 760;
    if (!this.referenceObject) {
      console.log('SioCombox: no reference object set');
    }
    if (this.referenceObject) {
      console.log(`referenceObject height is ${this.referenceObject.clientHeight}`);
      height = height - (this.referenceObject.clientHeight + 60);
    }
    return height;
  }

  public cssComputeInnerScroll() {
    console.log(`SioCombox clientHeight: ${this.shadowRoot.querySelector('.mainbox').clientHeight}`);
    console.log(`SioCombox content scrollheight is: ${this.shadowRoot.querySelector('.contentbox').clientHeight}`);
    if (this.shadowRoot.querySelector('.mainbox').clientHeight < this.shadowRoot.querySelector('.contentbox').clientHeight) {
      (this.shadowRoot.querySelector('.mainbox') as HTMLElement).style.overflowY = 'scroll';
    } else {
      (this.shadowRoot.querySelector('.mainbox') as HTMLElement).style.overflowY = 'hidden';
    }
  }

  constructor() {
    super();
    domtools.DomTools.setupDomTools();
  }

  public render(): TemplateResult {
    return html`
      ${domtools.elementBasic.styles}
      <style>
        :host {
          overflow: hidden;
          font-family: Roboto Mono;
          position: absolute;
          display: block;
          height: ${this.cssComputeHeight()}px;
          width: 375px;
          background: ${this.goBright ? '#eeeeee' : '#222222'};
          border-radius: 3px;
          right: 0px;
          z-index: 10000;
          box-shadow: 0px 0px 5px ${this.goBright ? 'rgba(0, 0, 0, 0.3)' : 'rgba(0, 0, 0, 0.5)'};
          color: ${this.goBright ? '#333' : '#ccc'};
          cursor: default;
          user-select: none;
          text-align: left;
        }

        .mainbox {
          position: absolute;
          height: 100%;
          width: 100%;
          overflow: hidden;
        }

        .toppanel {
          height: 200px;
          box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
          padding: 20px;
          --bg-color: ${this.goBright ? '#00000050' : '#ffffff30'};
          --dot-color: #ffffff00;
          --dot-size: 1px;
          --dot-space: 6px;

          background: linear-gradient(45deg, var(--bg-color) 1px, var(--dot-color) 1px) top left;
          background-size: var(--dot-space) var(--dot-space);
          margin-bottom: -50px;
        }

        #greeting {
          padding-top: 50px;
          font-family: Roboto;
          margin: 0px;
          font-size: 30px;
          font-weight: 100;
        }

        #callToAction {
          font-family: Roboto;
          margin: 0px;
          font-weight: 300;
        }

        .brandingbox {
          text-align: center;
          position: absolute;
          width: 100%;
          bottom: 0px;
          left: 0px;
          font-size: 10px;
          padding: 3px;
          border-top: 1px solid rgba(250, 250, 250, 0.05);
          font-family: Roboto Mono;
          box-shadow: 0px 0px 5px rgba(0,0,0,0.2);
          background: ${this.goBright ? '#EEE' : '#222'}
        }
      </style>
      <div class="mainbox">
        <div class="contentbox">
          <div class="toppanel">
            <div id="greeting">Hello :)</div>
            <div id="callToAction">Ask us anything or share your feedback!</div>
          </div>
          <sio-subwidget-conversations></sio-subwidget-conversations>
          <sio-subwidget-onboardme></sio-subwidget-onboardme>
        </div>
      </div>
      <div class="brandingbox">we run on social.io (by lossless)</div>
    `;
  }

  async updated() {
    this.cssComputeHeight();
    window.requestAnimationFrame(() => {
      setTimeout(() => {
        this.cssComputeInnerScroll();
      }, 200);
    });
  }
}
